<myarvato-title [searchbar]="true" [darkMode]="false" [big]="true" [title]="'pages.transport.tracking-tabs.title' | translate">
  <myarvato-fake-searchbar
    searchbar
    [placeholder]="'pages.transport.tracking-tabs.search-placeholder' | translate"
    (OnClick)="onSearchbarClick()"
  ></myarvato-fake-searchbar>
</myarvato-title>

<div class="container">
  @if (errorMessage(); as error) {
    <div class="row">
      <div class="col-12 mt--64 mb--64">
        <p-message [closable]="false" severity="error" size="large" icon="pi pi-times-circle" [text]="error"></p-message>
      </div>
    </div>
  }

  <div class="row">
    <div class="col-12">
      <div class="d-flex flex-row justify-content-end gap-2 py-2">
        <p-button
          icon="pi pi-plus align-middle"
          (onClick)="onSearchbarClick()"
          styleClass="mr--4"
          [label]="'pages.transport.tracking-tabs.add-tab' | translate"
          aria-label="'pages.transport.tracking-tabs.add-tab' | translate"
          variant="text"
        />

        @if (hasTabs()) {
          <p-button
            icon="pi pi-times align-middle"
            (onClick)="onCloseAllTabs()"
            styleClass="mr--4"
            [label]="'pages.transport.tracking-tabs.close-all-tabs' | translate"
            aria-label="'pages.transport.tracking-tabs.close-all-tabs' | translate"
            variant="text"
          />
        }
      </div>
    </div>
  </div>

  @if (hasTabs()) {
    <div class="row">
      <div class="col-12 mb--64">
        <p-tabs [value]="selectedTabName()" (valueChange)="onTabChange($event?.toString())" scrollable>
          <p-tablist class="tracking__tabs">
            @for (tab of userTabs(); track tab.displayName) {
              <div class="tracking__tabs__tab__container" [class.tracking__tabs__tab__container--active]="tabRef.active()">
                <p-tab [value]="tab.displayName" class="tracking__tabs__tab" [class.tracking__tabs__tab--active]="tabRef.active()" #tabRef>
                  <span class="h-100 align-middle" data-clarity-mask="true">
                    {{ tab.displayName }}
                  </span>
                </p-tab>
                <p-button
                  (onClick)="onTabClose(tab)"
                  [class.tracking__tabs__tab__close--active]="tabRef.active()"
                  variant="text"
                  class="tracking__tabs__tab__close"
                >
                  <i [class.tracking__tabs__tab__close--active]="tabRef.active()" class="pi pi-times link--icon align-middle"></i>
                </p-button>
              </div>
            }
          </p-tablist>

          <p-tabpanels class="mt--16 p--0">
            @for (tab of userTabs(); track tab.displayName) {
              @if (loadedTabNames().has(tab.displayName) || selectedTabName() === tab.displayName) {
                <p-tabpanel [value]="tab.displayName">
                  <transport-tracking-tab [transportReference]="tab.data.transportId"></transport-tracking-tab>
                </p-tabpanel>
              }
            }
          </p-tabpanels>
        </p-tabs>
      </div>
    </div>
  } @else {
    <div class="row">
      <div class="col-12 mt--64 mb--64">
        <transport-empty-state></transport-empty-state>
      </div>
    </div>
  }
</div>

<ng-template #searchDialogRowTemplate let-item>
  <div data-clarity-mask="true">{{ item.trackingNumber }} • {{ item.shipToName1 }}, {{ item.shipToStreet }}, {{ item.shipToCity }}</div>
</ng-template>
